module.exports = __webpack_public_path__ + "img/non planproduct.c3ed43ba.svg";